export default {
  avatar: 'avatar',
  id: 'id',
  code: 'code',
  action: 'action',
};
